import { TournamentState } from '@ps/poker-games-tile-mappers';
import { differenceInDays } from 'date-fns';

import type { Tournament } from '@swf/poker';
import { stateTimeComparator } from '@swf/poker';

import type { MainEventTournament } from '../types';

const TOURNAMENT_STATES_ORDER: Partial<{
  [K in TournamentState]: number;
}> & { default: number } = {
  default: 100,
  [TournamentState.RUNNING]: 1,
  [TournamentState.SEATING]: 2,
  [TournamentState.LATE_REGISTRATION]: 3,
  [TournamentState.REGISTERING]: 4,
  [TournamentState.PAUSED]: 5,
  [TournamentState.COMPLETED]: 6,
  [TournamentState.ANNOUNCED]: 7,
  [TournamentState.RESTRICTED]: 98,
  [TournamentState.CANCELLED]: 99
};

const getOrder = (tournament: Tournament): number => {
  const closeDayDiff = tournament.timeClosed
    ? differenceInDays(new Date(tournament.timeClosed), Date.now())
    : 0;
  if (tournament.formattedState === TournamentState.COMPLETED && closeDayDiff >= 1) {
    return TOURNAMENT_STATES_ORDER.default;
  }

  return TOURNAMENT_STATES_ORDER[tournament.formattedState] || TOURNAMENT_STATES_ORDER.default;
};

export default function getMainEventTournament(tournaments: Tournament[]): MainEventTournament {
  const [first, ...rest] = tournaments.sort((a, b) => stateTimeComparator(a, b, getOrder));
  if (![TournamentState.RUNNING, TournamentState.COMPLETED].includes(first?.formattedState)) {
    return first;
  }

  const nextAnnounced = rest?.find((r) => r.formattedState === TournamentState.ANNOUNCED) || {
    whenStartInt: undefined
  };
  return { ...first, nextWhenStartInt: nextAnnounced.whenStartInt };
}
